<template>
  <nav class="w-full z-20 flex items-center bg-white shadow-lg">
    <div class="flex-[1] min-w-[50px]"></div>

    <div class="grid gap-0.5 grid-cols-12">
      <div
        v-for="item in homeTopNavLinks"
        :key="item.id"
        @click="setActive(item)"
        class="cursor-pointer p-3 border flex flex-col items-center !border-gray-200 hover:text-primary-main rounded-md hover:!border-primary-main duration-200"
        :class="navActive === item.id ? '!bg-primary-main !text-white' : 'nav-link'"
      >
        <div class="h-7 w-7 grid place-items-center">
          <component :is="item.icon" :fill="navActive === item.id ? 'white' : undefined" />
        </div>
        <span class="text-sm text-center mt-2">{{ item.title }}</span>
        <v-tooltip
          :key="item.id"
          activator="parent"
          location="bottom"
          ><div class="w-40 whitespace-normal text-center">{{ item.tooltip }}</div></v-tooltip
        >
      </div>
    </div>

    <div class="cursor-pointer flex-[2] grid place-items-center" @click="goToWebsite">
      <figure class="mx-auto w-[150px] aspect-[5/3]">
        <img src="@/assets/images/logo.png" alt="Logo" class="w-full h-full object-contain" />
      </figure>
    </div>
  </nav>
</template>

<script lang="ts">
import { homeTopNavLinks } from '@/utils/homeLinks';
import { usePayloadStore } from '../../stores/payload';
import { Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { socket } from "../../socket";
export default class Dashboard extends Vue {
  public navActive: string | null = '';
  private payloadStore = usePayloadStore();

  @Watch('payloadStore.payload')
  public onNavActive() {
    this.navActive = this.payloadStore.payload.selectedModule;
  }

  mounted() {
    this.navActive = this.payloadStore.payload.selectedModule;
  }

  private currentModule: any = null;

  public homeTopNavLinks: any = homeTopNavLinks;

  public setActive(mod: any) {
    console.log('Toggle ', mod.title);

    if (!this.currentModule || this.currentModule !== mod) {
      this.currentModule = mod as any;
    } else if (this.currentModule === mod) {
      this.currentModule.active = false;
      this.navActive = null;
      this.currentModule = null;
      this.payloadStore.change({ selectedModule: '' });
      return;
    }

    for (const key in this.homeTopNavLinks) {
      let element: any = (this.homeTopNavLinks as any)[key];
      if (element === mod && !element?.disabled) {
        this.navActive = element.id;
        //selectedModule used in so many places. Can't make it object.
        socket.off();
        this.payloadStore.change({ selectedModule: element.id });
      } else {
        element.active = false;
      }
    }
  }

  public goToWebsite() {
    (window.open(process.env.WEB_BASE_URL, '_blank') as any).focus();
  }
}
</script>

<style scoped lang="css">
.nav-link:hover svg,
.nav-link:hover .nav-link-icon,
.nav-link:hover .svg-path {
  fill: #1890ff !important;
}
</style>
<style>
.nav-link:hover svg path {
  stroke: #1890ff !important;
}
</style>